// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__o3KTL","sendOtp":"AuthorizeToLogin_sendOtp__2I0yB"};